import React from "react";
import { Link } from "react-router-dom";
import { Instagram, School } from "lucide-react";
import { Badge } from "./ui";
import ProfileThumbnail from "./ProfileThumbnail";
import { formatInstagramHandle } from "../lib/instagram";

export default function HostCard({ host, compact = false }) {
  const ig = host.school_instagram;
  const igLabel = formatInstagramHandle(ig);
  const profilePath = host.organizer_id ? `/host/${host.organizer_id}` : null;

  const inner = (
    <div className={`flex items-start gap-3 ${profilePath ? "group" : ""}`}>
      <ProfileThumbnail
        name={host.name}
        role={host.role === "co_host" ? "Both" : null}
        thumbnailUrl={host.thumbnail_url}
        size="host"
        className="bg-cream"
      />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <p className="font-ui font-semibold text-[16px] leading-tight">{host.name}</p>
          {host.role === "co_host" && (
            <Badge color="sky">Co-host</Badge>
          )}
        </div>
        {host.school_name && host.runs_school !== false && (
          <p className="text-[13px] font-medium text-ink/65 mt-0.5 flex items-center gap-1">
            <School className="w-3 h-3" strokeWidth={2} /> {host.school_name}
          </p>
        )}
        {igLabel && !compact && (
          <p className="text-[12px] font-medium text-ink/50 mt-1 flex items-center gap-1">
            <Instagram className="w-3 h-3" strokeWidth={2} /> {igLabel}
          </p>
        )}
        {profilePath && (
          <p className="text-[12px] font-medium text-ink/45 mt-1 group-hover:text-ink/70 transition-colors">View profile →</p>
        )}
      </div>
    </div>
  );

  if (profilePath) {
    return (
      <Link
        to={profilePath}
        className="block quiet-card quiet-card-interactive rounded-card bg-surface p-3"
        data-testid={`host-card-${host.organizer_id}`}
      >
        {inner}
      </Link>
    );
  }
  return (
    <div className="quiet-card rounded-card bg-surface p-3" data-testid={`host-card-${host.name}`}>
      {inner}
    </div>
  );
}
